import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import Container from '../../UI/Layout/Container';
import Col from '../../UI/Layout/Col';

function PageNotFound({ isB2cPage })
{
    return (
        <Container className="tw-flex tw-w-full tw-min-h-screen">
            <Col className="tw-self-center tw-text-center tw-p-3 tw-text-gray-500">
                <h1 className="tw-text-9xl tw-text-primary-default tw-mb-5">404</h1>
                We could not find the page you are looking for
                <div className="tw-py-5">
                    <a className="tw-rounded tw-text-white tw-px-4 tw-py-2 tw-bg-primary-default hover:tw-bg-primary-default-hover" href="/">Back Home</a>
                </div>
            </Col>

            <Helmet title={`Page not found | ${isB2cPage ? 'Luxuria Vacations' : 'UJV'}`}>
                <meta name="description" content="Page not found" />
            </Helmet>
        </Container>
    );
}

PageNotFound.defaultProps = {
    isB2cPage: false,
};

PageNotFound.propTypes = {
    isB2cPage: PropTypes.bool,
};

export default PageNotFound;
